module.exports = __webpack_public_path__ + "img/02-tittle-01.311e7381.png";